<template>
  <div class="page-container">
    <div class="page-header">
      <HeaderCom></HeaderCom>
    </div>
    <div class="scene-main">
      <div id="emailbox" style="height:100%">
        <el-row style="height:100%">
          <el-col
            style="height:100%;border-right: 1px solid #c4dffb;width: 300px;"
          >
            <el-scrollbar style="background-color: #eff6fb;height:100%">
              <ul id="customerList" style="height:100%">
                <li
                  style="padding: 10px;text-align: center;font-size: 16px;color: #333;border-bottom: 1px solid #cde5fc;"
                >
                  客户列表
                </li>
                <li
                  @click="selectUser(item.userId, index, item.real, item)"
                  v-for="(item, index) in emailList"
                  :key="index"
                  :class="
                    index == xuanzhong ? 'cus-item cus-active' : 'cus-item'
                  "
                >
                  <div class="cus-info" style="line-height: 70px;height: 70px;">
                    <img
                      v-bind:src="
                        item.image || require('./img/user-header.png')
                      "
                      style="height: 48px;width: 48px;margin-top: 11px;border: 1px solid #666666;border-radius: 24px;"
                    />
                    <i
                      class="el-icon-message"
                      v-if="item.count > 0"
                      style="color: blue;margin: 10px -10px 0 0"
                    ></i>
                    <div class="cus-txt" style="text-align: left;margin: 15px;">
                      <div style="font-size: 14px;line-height: 20px;">
                        {{ item.name }}
                      </div>
                      <div
                        style="font-size: 12px;vertical-align: top;line-height: 20px;color: #555555;"
                      >
                        {{ item.question.issue }}
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </el-scrollbar>
          </el-col>
          <el-col style="height:100%;width: calc(100% - 650px)">
            <div class="chatbox" style="height:100%">
              <div class="chat-title">{{ currentName }}</div>
              <el-scrollbar style="height: calc(100% - 250px);">
                <div class="chat-box">
                  <!-- 客户 -->
                  <div
                    v-for="(item, index) in chatList"
                    :key="index"
                    class="chat-item"
                  >
                    <div
                      v-if="item.createTime && showTime(item.createTime)"
                      class="chat-time"
                    >
                      {{ item.createTime | timestampToTime }}
                    </div>
                    <div v-else class="chat-time"></div>
                    <!-- 接收 -->
                    <div v-if="item.type == 0 && item.content" class="chat-kh">
                      <div>
                        <div class="chat-bg chat-icon1"></div>
                      </div>
                      <div class="chat-content">
                        <div class="chat-txt">
                          <div
                            class="chat-p"
                            style="margin-bottom: 0px;line-height: 1.7em;"
                          >
                            <p v-html="showHtml(item.content)"></p>
                            <!--<i title="翻译" @click="translateTxt(item.contentCN,'zh',item.id)"-->
                            <!--class="el-icon-search translate-icon"></i>-->
                          </div>
                          <div v-if="item.contentZh" class="chat-translate">
                            <p
                              class="chat-p"
                              style="margin-bottom: 0px;line-height: 1.7em;"
                              v-html="showHtml(item.contentZh)"
                            ></p>
                            <!--<div class="trans-close" @click="close(index)">-->
                            <!--<i class="el-icon-close"></i>-->
                            <!--</div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 回复 -->
                    <div v-else-if="item.content" class="chat-kh2">
                      <div>
                        <div class="chat-bg chat-icon2"></div>
                      </div>
                      <div class="chat-content2">
                        <div class="chat-txt2">
                          <p
                            class="chat-p"
                            style="margin-bottom: 0px;line-height: 1.7em;"
                            v-html="showHtml(item.content)"
                          ></p>
                          <div v-if="item.contentZh" class="chat-translate">
                            <p
                              class="chat-p"
                              style="line-height: 1.7em;"
                              v-html="showHtml(item.contentZh)"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
              <div style="border-top: 1px solid #c4dffb;height: 250px;">
                <div
                  style="height: 35px;line-height: 35px;vertical-align: middle;margin: 10px 10px 10px 20px;"
                >
                  <img
                    class="lan-img"
                    src="./img/yuyan.png"
                    alt=""
                    style="margin-right: 10px;"
                  />
                  <el-select
                    v-model="value"
                    placeholder=""
                    size="mini"
                    style="width:100px;"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="chat-input" style="height: 100px;">
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    placeholder=""
                    v-model="textarea3"
                    resize="none"
                  >
                  </el-input>
                </div>
                <div
                  style="height: 35px;line-height: 35px;vertical-align: middle;text-align:right;margin: 5px 10px 10px 20px;"
                >
                  <el-button @click="sentInfo" class="chat-sent" size="small"
                    >发送</el-button
                  >
                </div>
              </div>
            </div>
          </el-col>
          <el-col style="height:100%;width: 350px;">
            <div
              class="problembox"
              style="border-left: 1px solid #c4dffb;height: 100%;"
            >
              <img
                style="width: 100%;height: 130px;"
                src="./img/cjwt.jpg"
                alt=""
              />
              <el-scrollbar
                class="problemboxElSB"
                style="height:calc(100% - 113px)"
              >
                <div>
                  <el-collapse>
                    <el-collapse-item
                      v-for="(tpl, index) in emailTpl"
                      :key="index"
                      :class="tpl.className"
                      :title="`• ${tpl.title}`"
                      :name="index"
                    >
                      <template slot="title">
                        <div
                          style="display:flex;justify-content: space-between;width: 100%;padding-right: 30px;"
                        >
                          <span> • {{ tpl.title }} </span>
                          <span>
                            <i
                              class="el-icon-circle-plus-outline jia"
                              style="font-size:20px;color:#757575"
                            ></i>
                          </span>
                        </div>
                      </template>
                      <template
                        v-if="
                          tpl.children
                            ? tpl.children.length > 0
                              ? true
                              : false
                            : false
                        "
                      >
                        <email-child
                          :childData="tpl"
                          @AlertModal="search"
                        ></email-child>
                      </template>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-scrollbar>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 监听发送过来的childModalClose事件,并指向函数childModalClose -->
      <email-modal
        v-if="moadlShow"
        v-on:childModalClose="childModalClose"
        :tplData="tplData"
        @sendTpl="sendTpl"
      ></email-modal>
    </div>
    <div class="foot">
      <div class="submit-btnn">
        <button class="" @click="toNextRouter">
          <div class="text">
            下一步
          </div>
          <div class="subText">
            Merchandise on the shelves
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "@/components/headerCom";
import emailChild from "./email-child.vue";
import emailModal from "./emailModal.vue";
import { problemData } from "./data";
import { getRandomMessages } from "./util";
const userList = getRandomMessages();
export default {
  data() {
    return {
      emailList: userList,
      chatList: [
        {
          content: "",
          fanyi: "",
          createTime: "",
          id: "",
          serviceEmailId: "",
          type: "",
        },
      ],
      xuanzhong: 0,
      currentIndex: 0,
      currentName: "",
      currentId: "",
      yuyan: "中文",
      moadlShow: false,
      activeName: ["1"],
      activeName1: "",
      activeName3: "",
      activeName4: "",
      activeName5: "",
      textarea3: "",
      options: [
        {
          value: "zh",
          label: "中文",
        },
        {
          value: "en",
          label: "英文",
        },
        {
          value: "fra",
          label: "法语",
        },
      ],
      value: "zh",
      emailTpl: problemData,
      tplData: "",
    };
  },
  components: {
    HeaderCom,
    emailModal,
    emailChild,
  },
  props: ["childData"],
  created() {
    this.recordTime();
  },
  methods: {
    toNextRouter() {
      this.$router.push({
        path: "/sellerdecision",
        query: this.$route.query,
      });
    },
    sendTpl(data) {
      this.moadlShow = false;
      let $tpl =
        data.content.en.header +
        data.content.en.mainContent +
        data.content.en.footer;
      this.textarea3 = "";
      this.textarea3 = $tpl;
    },
    showTime() {
      return false;
    },
    showHtml(content) {
      if (!content) return;
      let html = content.replace(/\n/g, "<br>&nbsp;&nbsp;&nbsp;&nbsp;");
      return html;
    },
    selectUser(userId, index, real, item) {
      console.log(item);
      this.currentIndex = index;
      this.currentId = userId;
      this.currentName = real;
      this.xuanzhong = index;
      this.currentItem = item;
      this.chatList = [
        {
          content: item.question.messages,
          contentZh: "",
          createTime: "",
          id: "",
          recive: "",
          sender: "",
          status: "",
          type: 0,
        },
      ];
      if (item.reply) {
        this.chatList.push({
          content: item.reply.content,
          contentZh: item.reply.contentZh,
          createTime: "",
          id: "",
          recive: "",
          sender: "",
          status: "",
          type: 1,
        });
      }
    },
    sentInfo() {
      if (this.textarea3 == null || this.textarea3.trim() === "") {
        this.$alert("请输入内容", {
          confirmButtonText: "确定",
          callback: () => {},
        });
        return;
      }
      new Promise((resolve) => {
        let _txt = this.textarea3.replace(/\n/g, "").substring(0, 10);
        this.$languageFn(_txt).then((res) => {
          if (res.error_msg === "success") {
            resolve(res.data.src);
          }
          resolve("zh");
        });
      }).then((_to) => {
        const _textarea3 = this.textarea3.replace(/\n/g, "");
        this.$translateEn(_to, this.value, _textarea3)
          .then((res) => {
            this.emailList[this.currentIndex].reply = {
              content: res.trans_result[0].dst,
              contentZh: this.textarea3,
            };
            this.selectUser("", this.currentIndex, "", this.currentItem);
            this.textarea3 = "";
          })
          .catch(() => {});
      });
    },

    close(index) {
      this.chatList[index].contentZh = "";
    },
    search(content) {
      this.moadlShow = true;
      this.tplData = content;
    },
    childModalClose: function(modalClose) {
      // modalClose就是子组件传过来的值
      this.moadlShow = modalClose;
      document.querySelector("html").style.overflow = "auto";
    },
    recordTime() {
      // let ran = Math.random();
      // // this.$post("/student/online/submit", {
      // //   code: "CUSTOMER_SERIVCE",
      // //   random: ran,
      // //   note: "客服服务",
      // // }).then(() => {});
    },
    handlePaste() {
      return false;
    },
    translateTxt(txt, langeth, id) {
      this.$post("/common/translate/query", { dest: langeth, query: txt }).then(
        (res) => {
          let translate = res.translate;
          this.$post("/student/service/email/saveZh", {
            id: id,
            contentZh: translate,
          }).then(() => {
            // this.socket.emit("MessageHistory", { senderId: this.currentId }); //获取历史信息。
          });
        }
      );
    },
  },
  computed: {},
  filters: {
    timestampToTime(timestamp) {
      let date = new Date(timestamp);
      return date.$Format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>

<style scoped lang="scss">
@mixin title {
  padding-bottom: 0;
  margin-bottom: 10px;
  .text {
    font-size: 26px;
    font-weight: bold;
    line-height: 33px;
  }
  .subText {
    font-size: 12px;
    font-weight: 400;
    line-height: 15px;
    color: #999999;
  }
}

.page-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100vw;
  min-height: 100vh;
  background: url("./../../assets/image/simulation/bg.jpg");
  background-size: cover;
  padding-top: 60px;
  .page-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 60px;
    background: #005be7;
    padding: 0 20px;
  }
  .scene-main {
    width: calc(100% - 280px);
    height: calc(100vh - 180px);
  }
}
.foot {
  .submit-btnn {
    button {
      width: 200px;
      height: 64px;
      background: linear-gradient(90deg, #70a0eb 0%, #005be7 100%);
      box-shadow: 0px 3px 6px rgba(0, 91, 231, 0.3);
      opacity: 1;
      border-radius: 60px;

      &.left {
        border-radius: 60px 0 0 60px;
      }

      &.right {
        border-radius: 0 60px 60px 0;
      }

      .text {
        font-size: 22px;
        font-family: Microsoft YaHei UI;
        font-weight: 400;
        line-height: 26px;
        color: #ffffff;
      }

      .subText {
        font-size: 10px;
        font-weight: 400;
        line-height: 14px;
        color: #ffffff;
      }
    }
  }
}
</style>
<style>
#emailbox {
  border: 1px solid #e5e5e5;
  height: 100%;
  min-height: 350px;
}
#emailbox .el-row {
  height: 100%;
}
#emailbox #customerList {
  width: 100%;
  /* width: calc(100% + 18px); */
  list-style: none;
  padding-left: 0px;
  /* overflow-y: auto;
    overflow-x: hidden; */
}
#emailbox .msg-active {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fdc43a;
  margin-top: 20px;
  margin-left: 20px;
}
#emailbox .cus-item {
  height: 70px;
  padding: 0 10px 0 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #cde5fc;
}
#emailbox .cus-active {
  background-color: white;
}
#emailbox .cus-item:hover {
  background-color: white;
}
#emailbox .cus-info {
  width: 100%;
  overflow: hidden;
  display: flex;
}
#emailbox .cus-item:hover {
  cursor: pointer;
}
#emailbox .cus-img {
  display: inline-block;
  width: 48px;
  height: 48px;
}
#emailbox .cus-icon1 {
}
#emailbox .cus-icon2 {
}
#emailbox .cus-txt {
  width: calc(100% - 48px);
  margin-left: 14px;
}
#emailbox .cus-name {
  color: #333;
  font-size: 16px;
  margin: 3px 0px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-overflow: ellipsis;
}
#emailbox .cus-msg {
  width: 100%;
  color: #c1cada;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
/* #emailbox .el-scrollbar__wrap {
  margin-bottom: 0px !important;
} */
/*隐藏滚动条*/
#emailbox .aa {
  overflow-x: hidden;
}
#emailbox .bb {
  overflow-x: hidden;
  margin-left: 35px;
  margin-right: 35px;
}
/*中间*/
#emailbox .chatbox {
  padding: 0px 0px;
}
#emailbox .chat-item {
  padding: 0px 15px;
}
#emailbox .chat-title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  font-weight: 500;
  font-size: 18px;
  border-bottom: 1px solid #c4dffb;
}
#emailbox .chat-box {
  /* width: 100%; */
  padding-bottom: 20px;
}
#emailbox .chat-kh {
  display: flex;
}
#emailbox .chat-bg {
  display: inline-block;
  width: 40px;
  height: 40px;
  background-image: url("./img/Sprite.png");
  background-repeat: no-repeat;
  background-size: 250%;
  /* background-color: yellow; */
}
#emailbox .chat-icon1 {
  background-position: -31px -2258px;
}
#emailbox .chat-icon2 {
  background-position: -31px -2315px;
}
#emailbox .chat-kh2 {
  display: flex;
  margin-right: 20px;
  flex-direction: row-reverse;
}
#emailbox .chat-content {
  font-size: 12px;
  background-image: url("./img/chat1.png");
  background-repeat: no-repeat;
  max-width: 60%;
}
#emailbox .chat-content2 {
  font-size: 12px;
  background-image: url("./img/chat2.png");
  background-repeat: no-repeat;
  background-position-x: 100%;
  max-width: 60%;
}
#emailbox .chat-txt {
  padding: 20px;
  font-size: 12px;
  margin-left: 7px;
  border-radius: 5px;
  max-width: 100%;
  background-color: rgba(128, 169, 254, 0.8);
  color: white;
}
#emailbox .chat-txt > p {
  margin-bottom: 0px;
}
#emailbox .chat-txt2 {
  padding: 20px;
  margin-right: 7px;
  border-radius: 5px;
  max-width: 100%;
  background-color: #ebf5ff;
  color: #333;
}
#emailbox .chat-txt2 > p {
  margin-bottom: 15px;
}
#emailbox .chat-translate {
  width: 100%;
  margin-top: 10px;
  font-size: 12px;
  padding: 12px 12px 15px 15px;
  color: #333;
  background-color: white;
  border-radius: 5px;
  position: relative;
}
#emailbox .trans-close {
  position: absolute;
  right: 3px;
  bottom: 2px;
  font-size: 12px;
  color: #80a9fe;
}
#emailbox .trans-close:hover {
  cursor: pointer;
}
#emailbox .language {
  margin: 10px 20px;
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
}
#emailbox .lan-img {
  margin-right: 5px;
  position: relative;
  top: 5px;
}
#emailbox .chat-p {
  word-break: break-all;
}
#emailbox .chat-sent {
  background-color: rgba(255, 181, 86, 0.87);
  color: white;
  width: 76px;
  border: none;
}
#emailbox .chat-sent:hover {
  background: #ff5722;
}
#emailbox .chat-text > textarea {
  border: none;
  width: calc(100% + 18px);
}
#emailbox .chat-input {
  display: flex;
  justify-content: space-between;
}

#emailbox .el-textarea__inner {
  border: 0 !important;
}

#emailbox .chat-time {
  font-size: 14px;
  text-align: center;
  margin: 28px 0px 13px 0px;
  color: #8cabc5;
}
#emailbox .translate-icon {
  float: right;
  top: -10px;
  position: relative;
  margin: 10px -10px 0 0;
  color: white;
}
#emailbox .translate-icon:hover {
  cursor: pointer;
}

/*右栏内容*/
#emailbox .problembox {
  overflow: hidden;
  background-color: #eff6fb;
}
/**/

/**/
#emailbox .problem1 > div > div {
  background-color: #a8d1fc;
  padding-bottom: 0px;
}
#emailbox .problem1 > div > div.el-collapse-item__header {
  padding-left: 20px;
}
#emailbox .problem2 > div > div {
  background-color: #d5e8ff;
  padding-bottom: 0px;
}
#emailbox .problem2 > div > div.el-collapse-item__header {
  padding-left: 40px;
}
#emailbox .problem3 > div > div {
  background-color: #e8f4ff;
  border-bottom: 1px solid white;
  padding-bottom: 0px;
}
#emailbox .problem3 > div > div.el-collapse-item__header {
  padding-left: 60px;
}

#emailbox .problem4 > div > div {
  background-color: #e8ffff;
  border-bottom: 1px solid white;
  padding-bottom: 0px;
}
#emailbox .problem4 > div > div.el-collapse-item__header {
  padding-left: 80px;
}

#emailbox .search {
  height: 48px;
  line-height: 48px;
  background-color: #e8f4ff;
  padding-left: 80px;
  position: relative;
  border-bottom: 1px solid #ffffff;
  padding-right: 60px;
}
#emailbox .problem1 > div > div.el-collapse-item__content > div > .search {
  padding-left: 40px;
}
#emailbox .search:last-child {
  border-bottom: none;
}
/*折叠面板*/
.problemboxElSB .el-collapse-item__arrow.el-icon-arrow-right {
  display: none;
}
#emailbox .problem1 > div > div {
  position: relative;
}
.el-collapse-item__header.is-active i.jia {
  display: none;
}
#emailbox .problem1 > div > div > .is-active:before {
  content: "-";
  width: 24px;
  height: 24px;
  background-color: white;
  text-align: center;
  line-height: 24px;
  font-size: 16px;
  color: #84a9c7;
  top: 12px;
  right: 20px;
  border-radius: 50%;
}
#emailbox .problem1 > div > div .el-collapse-item__arrow.is-active {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
#emailbox .problem1 > div > div .el-collapse-item__arrow {
  margin-right: 0px;
}
#emailbox .problem2 > div > div {
  position: relative;
}
#emailbox .problem2 > div > div > .is-active:before {
  content: "-";
}
#emailbox .problem2 > div > div .el-collapse-item__arrow.is-active {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
#emailbox .problem3:last-child > div > div {
  border-bottom: none;
}
#emailbox .problem3 > div > div {
  position: relative;
}
#emailbox .problem3 > div > div > .is-active:before {
  content: "-";
}
#emailbox .problem3 > div > div .el-collapse-item__arrow.is-active {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}
#emailbox .problem3 > div > div .el-collapse-item__arrow {
  margin-right: 0px;
}
#emailbox .problembox .search-btn {
  display: inline-block;
  color: white;
  background-color: #ffc84a;
  width: 23px;
  height: 23px;
  border-radius: 50%;
  text-align: center;
  line-height: 23px;
  position: absolute;
  top: 12px;
  right: 30px;
}
#emailbox .problembox .search-btn:hover {
  cursor: pointer;
}
</style>
